module.exports = __webpack_public_path__ + "static/img/5-info.85b4524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/5-info.png
// module id = 2O1g
// module chunks = 0